export enum ColorEnum {
    LightColor = '#FFFFFF',
    DarkColor = '#002439'
}
